export default "__VITE_ASSET__a6740455__"